import { memo } from 'react'
import { isEqual } from 'lodash'
import { PageTitle } from 'app/components/common/PageTitle'
import R from 'app/assets/R'
import { useTranslation } from 'react-i18next'
import CustomerCarePlanContainer from 'app/containers/CustomerCare/CustomerCarePlan'

const CustomerCarePlanPageCpn = () => {
  const { t } = useTranslation()
  return (
    <>
      <PageTitle>{t(R.strings.customer_care_plan)}</PageTitle>
      <CustomerCarePlanContainer />
    </>
  )
}
const CustomerCarePlanPage = memo(CustomerCarePlanPageCpn, isEqual)

export default CustomerCarePlanPage
